<template>
  <div class="body">
    <div class="main_container">
      <training-header :appConfig="appConfig"></training-header>

      <!-- page content -->
      <div class="right_col" role="main" style="margin-left: 0; background-color: #fff;">
        <div class="row">
          <div v-html="facilitatorObj.faqContent"></div>
        </div>
      </div>
      <training-footer :appConfig="appConfig"></training-footer>
    </div>
  </div>
</template>
<script>
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';
import ApiServices from '../service/ApiServices';
export default {
  data(){
    return {
      facilitatorObj:{},
      appConfig:{}
    }
  },
  components: {
    trainingHeader,
    trainingFooter
  },
  mounted(){
    if(this.$route.params.facilitatorObj){
      this.facilitatorObj = this.$route.params.facilitatorObj
    }
    if(this.$route.params.appConfig){
      this.appConfig = this.$route.params.appConfig
    }
  },
}
</script>
<style lang="scss" scoped>
</style>
